var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticStyle: {
        "z-index": "999999999999999999",
        background: "grey !important"
      },
      attrs: {
        visible: _vm.pdfPreviewDialogVisible,
        width: "70%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.pdfPreviewDialogVisible = $event
        }
      }
    },
    [
      _c("pdf", {
        attrs: { src: `data:application/pdf;base64,${_vm.PDFPreviewData}` }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }